import { render, staticRenderFns } from "./BSIMS.vue?vue&type=template&id=10eb6b9e&scoped=true&"
import script from "./BSIMS.vue?vue&type=script&lang=js&"
export * from "./BSIMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb6b9e",
  null
  
)

export default component.exports